<div class="page-sub-title">All Rounds</div>
<div class="card">
    <table>
        <tr>
            <th></th>
            <th colspan="3">Rounds</th>
            <th></th>
        </tr>
        <tr>
            <th>Player</th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>Avg.</th>
        </tr>
        <tr *ngFor="let p of players">
            <td>{{p.firstName}} {{p.lastName}}</td>
        </tr>
    </table>
</div>